import { render, staticRenderFns } from "./TableCars.vue?vue&type=template&id=28977c1a"
import script from "./TableCars.vue?vue&type=script&lang=js"
export * from "./TableCars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports